import React from 'react';
import logo from '../../../images/VI-logo-new.png';
import '../Style/Welcome.css';
import {IPropsView} from '../Config/Welcome.types';
import {_SYSTEM_TITLES} from '../../../configuration/index.config';

const Welcome = ({classNameTop, classNameImage, classNameH1, title = `Welcome To ${_SYSTEM_TITLES.systemNameFull}`}:IPropsView) => (
    <div className={classNameTop}>
        <img
            alt='techsee logo'
            src={logo}
            className={classNameImage}/>
        <h1 className={classNameH1}>{title}</h1>
    </div>
);

export default Welcome;
